/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
/* eslint-disable sort-keys */
import {Sandbox} from '@exc/core';

export default {
  appId: 'cloudManagerUi',
  distributionList: ['cm-dev@adobe.com'],
  path: '/cloud-manager',
  serviceCode: 'dma_aem_cloud',
  sandbox: {
    ims: {
      client_id: 'ssp_ui',
      scope: 'openid,AdobeID,session,read_organizations,additional_info.projectedProductContext,additional_info.user_image_url,additional_info.roles'
    },
    hideInitialSpinner: true,
    history: Sandbox.HISTORY_TYPES.HISTORY,
    sources: {
      local: 'https://local.corp.adobe.com',
      cat: 'https://self-service-commerce-cvui-dev.corp.ethos01-stage-va6.ethos.adobe.net',
      dev: 'https://dev-cloudmanager.azurewebsites.net',
      qa: 'https://dev-cloudmanager.azurewebsites.net',
      qa1: 'https://qa1-cloudmanager.azurewebsites.net',
      qa2: 'https://qa2-cloudmanager.azurewebsites.net',
      qa3: 'https://qa3-cloudmanager.azurewebsites.net',
      qa4: 'https://qa4-cloudmanager.azurewebsites.net',
      qa5: 'https://qa5-cloudmanager.azurewebsites.net',
      stage: 'https://my.stage.cloudmanager.adobe.com',
      prod: 'https://my.cloudmanager.adobe.com'
    }
  },
  access: ['dma_aem_ams', 'dma_aem_cloud']
};
